{
  "fr": {
    "form": {
      "actions": {
        "cancel": "Annuler",
        "clear": "Effacer",
        "closeFullPage": "Fermer la page",
        "copyText": "Cliquez pour copier le texte",
        "create_and_send_to_customer": "Créer et envoyer au client",
        "create_and_share": "Créer et partager avec le client",
        "create_and_share_partners_only": "Créer et partager avec les partenaires",
        "create_and_share_with_partners": "Créer et partager avec le client et les partenaires",
        "next": "Suivant",
        "only_create": "Créer uniquement",
        "openFullPage": "Ouvrir en pleine page",
        "save": "Sauvegardez",
        "saveChanges": "Sauvegardez les modifications",
        "search": "Rechercher...",
        "send": "Envoyer",
        "send_and_create_another": "Envoyer et créer un autre",
        "send_to_customer": "Envoyer au client",
        "share_with_customer": "Partager avec le client",
        "submit": "Envoyer",
        "submit_and_create_another": "Soumettre et créer un autre"
      },
      "back": "Etape précédente",
      "labels": {
        "columns": "Colonnes",
        "no_results": "Pas de résultats"
      },
      "notifications": {
        "textHasBeenCopied": "Le texte a été copié"
      },
      "password": "Mot de passe",
      "shortcuts": {
        "save_mac": "⌘ + Entrée pour sauvegarder",
        "save_windows": "Ctrl + Entrée pour enregistrer",
        "send_mac": "⌘ + Entrée pour envoyer",
        "send_windows": "Ctrl + Entrée pour envoyer"
      },
      "steps": "Etape {count} sur {total}",
      "writeEmployeeNameReject": "Noter <i><b>{employeeName}</b></i> pour terminer la suppression."
    }
  }
}
